// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Sidebar */
.sidebar {
  display: flex;
  width: 100%;
  flex-shrink: 0;
  flex-direction: column;
  border-right: 1px solid var(--border-color);
  background-color: var(--bg-card);
}

@media (min-width: 768px) {
  .sidebar {
    width: 320px;
  }
}

@media (min-width: 1024px) {
  .sidebar {
    width: 380px;
  }
}

.dark .sidebar {
  background-color: var(--bg-main);
}

/* Sidebar Header */
.sidebar-header {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.25rem;
  border-bottom: 1px solid var(--border-color);
}

/* Sidebar Title Row */
.sidebar-title-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 0.25rem;
}

/* Sidebar Logo Group */
.sidebar-logo-group {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

/* App Logo */
.app-logo {
  width: 2rem;
  height: 2rem;
}
`, "",{"version":3,"sources":["webpack://./src/styles/layout/sidebar.css"],"names":[],"mappings":"AAAA,YAAY;AACZ;EACE,aAAa;EACb,WAAW;EACX,cAAc;EACd,sBAAsB;EACtB,2CAA2C;EAC3C,gCAAgC;AAClC;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE;IACE,YAAY;EACd;AACF;;AAEA;EACE,gCAAgC;AAClC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,4CAA4C;AAC9C;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,sBAAsB;AACxB;;AAEA,uBAAuB;AACvB;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;AACd;;AAEA,aAAa;AACb;EACE,WAAW;EACX,YAAY;AACd","sourcesContent":["/* Sidebar */\n.sidebar {\n  display: flex;\n  width: 100%;\n  flex-shrink: 0;\n  flex-direction: column;\n  border-right: 1px solid var(--border-color);\n  background-color: var(--bg-card);\n}\n\n@media (min-width: 768px) {\n  .sidebar {\n    width: 320px;\n  }\n}\n\n@media (min-width: 1024px) {\n  .sidebar {\n    width: 380px;\n  }\n}\n\n.dark .sidebar {\n  background-color: var(--bg-main);\n}\n\n/* Sidebar Header */\n.sidebar-header {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  padding: 1.25rem;\n  border-bottom: 1px solid var(--border-color);\n}\n\n/* Sidebar Title Row */\n.sidebar-title-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 0.25rem;\n}\n\n/* Sidebar Logo Group */\n.sidebar-logo-group {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n}\n\n/* App Logo */\n.app-logo {\n  width: 2rem;\n  height: 2rem;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
